// extracted by mini-css-extract-plugin
module.exports = {"socialShare":"tOSNQ","timelineshare":"k_tEB","icon_share":"xRmlk","shareicon":"UNpz3","active":"T3BX7"};